import { logger } from '@gem/modules/logger';

import Entities from 'STORE';

// Needs Bff implementation
export const getRewardsProgress = async (): Promise<void> => {
  try {
    const response = { rewardsInfo: [] };

    Entities.rewards.setRewardsProgress(response.rewardsInfo);
    Entities.rewards.setRewardsProgressLoading(false);
  } catch (error) {
    logger.get('API').error('userSettings.getRewardsProgress', error);
  }
};
